import { Component, EventEmitter, Input, OnChanges, OnInit, Renderer2, SimpleChanges, ViewChild, HostListener, Output, Inject, ChangeDetectionStrategy, NgZone, ElementRef } from '@angular/core';
import { ActivatedRoute, Event, Router } from '@angular/router';

//import { ImageViewerComponent } from '../../../shared/components/ng2-image-viewer';
import { DocBasketComponent } from '../../../shared/components/doc-basket/doc-basket.component';
import { ShoppingBasketService } from '../../../shared/services/shopping-basket.service';
import { NavMenuService } from '../../../shared/services/nav-menu-service';
import { basketVM } from '../../../shared/viewmodels/basketVM';
import { InstrumentVM, RecDocVM } from '../../../shared/viewmodels/ISearchService';
import { RecSearchService } from '../../rec-search-service';
import { DocBasketExComponent } from '../../../shared/components/doc-basket-ex/doc-basket-ex.component';
import { RecPlanSearchService } from '../../../rec-plan-search/rec-plan-search-service';
import { NgxExtendedPdfViewerComponent, PdfBreakpoints, pdfDefaultOptions } from 'ngx-extended-pdf-viewer';

@Component({
  selector: 'app-rec-doc-detail-parent',
  providers: [RecSearchService],
  templateUrl: './rec-doc-detail-parent.component.html',
  styleUrls: ['./rec-doc-detail-parent.component.css'],
  changeDetection: ChangeDetectionStrategy.OnPush 
})
export class RecDocDetailParentComponent implements OnInit {

  //@ViewChild(ImageViewerComponent) imageViewerChild;
  @Input() docId: number;
  @Input() book: string;
  @Input() page: string;
  @Input() index_page: string;
  public pageCount: number;
  @Input() searchType: string;
  public currentIndex: number;
  public currentImageIndex: number;
  public docImages: Array<string>;
  @Input() currentImage: Array<string>;
  public blobImage: string;
  public documents: Array<InstrumentVM>;
  public bufferSize: number = 5;
  public record: RecDocVM;
  public inst: InstrumentVM;
  public isLoadingImage: boolean = true;
  public isLoadingDetail: boolean = true;
  public showimageviewer: boolean = true;
  public isImgVwVisible: boolean = true;
  public allowDownload: boolean = false;
  error: any;
  evtEmitter = new EventEmitter();
  previewImage: any;
  public imgvwr: any;
  public docbeginbook: any;
  public docbeginpage: any;
  public isFirstPage: boolean;
  public isLastPage: boolean;
  public returnbook: string;
  public returnpage: string;
  public sBook: string;
  public sPage: string;
  public sPlanBook: string;
  public sPlanPage: string;
  public isPlanBook: boolean = false;
  @ViewChild(DocBasketComponent, { static: false }) docBasketChild: DocBasketExComponent;
  @ViewChild(NgxExtendedPdfViewerComponent, { static: false }) pdfViewer: NgxExtendedPdfViewerComponent;

  basketItem: basketVM;
  collapseGo: boolean = false;
  collapseReturn: boolean = false;
  screenWidth: any;
  @Output() public changeImgVwVisible = new EventEmitter();
  @Output() public changeInInfo = new EventEmitter<RecDocVM>();
  popupVisible: boolean = false;
  Message: string;
  appurl: string;
  public showLoader: boolean;
  emptyImage: boolean;
  showPaging: boolean = true;
  pagingBookLimit: number = 439;
  planBookLimit: number = 246;

  constructor(private route: ActivatedRoute,
    private service: RecSearchService, private SBService: ShoppingBasketService,
    private router: Router, private renderer: Renderer2, public nav: NavMenuService, @Inject('BASE_URL') baseUrl: string, private ngZone: NgZone) {
    this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.documents = new Array<InstrumentVM>();
    console.log('bp ' + this.book + ' ' + this.page + ' ' + this.docId);
    this.book = this.route.snapshot.paramMap.get('book');
    this.page = this.route.snapshot.paramMap.get('page');
    //console.log('page: ' + this.page);
    this.docId = Number(this.route.snapshot.paramMap.get('docId'));

    // initialize counters to hold first page of a document.
    this.docbeginbook = this.book;
    this.docbeginpage = this.page;

    // initialize counters to hold book/page to return to initial search.
    this.returnbook = this.book;
    this.returnpage = this.page;
    this.nav.hide();
    this.getScreenSize();
    this.appurl = baseUrl;
    pdfDefaultOptions.maxCanvasPixels = -1;
    //PdfBreakpoints.xs = 150;
    //PdfBreakpoints.sm = 200;

    //this.pdfViewer.nativeElement.PdfBreakpoints.xs = 200;
    //console.log('rec-doc-detail-parent constructor fired');
  }

  @HostListener('document:keydown', ['$event'])
  onKeyDown(event: KeyboardEvent) {
    if (event.code === 'PageUp') {
      this.getPrevDocument(null);
    } else if (event.code === 'PageDown') {
      this.getNextDocument(null);
    } else if (event.code === 'ArrowLeft') {
      if (!this.isFirstPage) {
        this.getPrevPg(null);
      }
    } else if (event.code === 'ArrowRight') {
      if (!this.isLastPage) {
        this.getNextPg(null);
      }
    } else if (event.code === 'ArrowUp') {
      if (!this.isFirstPage) {
        this.getFirstPg(null);
      }
    } else if (event.code === 'ArrowDown') {
      if (!this.isLastPage) {
        this.getLastPg(null);
      }
    } else if (event.code === 'Home') {
      this.returnToStart(this.returnbook, this.returnpage);
    }
  }


  receiveLoader($event) {
    this.showLoader = $event;
    console.log("show - " + this.showLoader)
  }

  /** Initialize image viewer */
  ngOnInit() {
//    console.log('ngOnInit() fired');
//    console.log('index pg ' + this.index_page);
    console.log("BOOK " + this.book);
    if (this.book === '0000') this.book = 'AX' + this.book;
    this.showPaging = (+this.book >= this.pagingBookLimit || this.book === 'AX0000');
    if (this.showPaging) console.log("SHOW PAGING");
    if (this.index_page)
      this.currentIndex = +this.index_page + 1;
    else
      this.currentIndex = 1;
    this.currentImageIndex = 0;
    //this.imageViewerChild = new ImageViewerComponent(this.renderer);
    this.isLoadingDetail = true;
    console.log('doc record ' + this.record == null);
    console.log('tp ' + this.searchType );
    if (!this.record) {
      this.service.getRecDoc(this.docId).subscribe(
        data => {
          this.record = data;
          this.pageCount = data.docDetail.pageCount;
          console.log('type '+ data.docDetail.docType);
          // initialize counters to hold first page of a document.
          this.docbeginbook = this.book;
          this.docbeginpage = this.page;
          this.isPlanBook = (this.record.docDetail.docType == 'PL' && +this.docbeginbook <= this.planBookLimit);
          //if (this.docbeginbook == null)
          //  this.docbeginbook = this.book;
          //if (this.docbeginpage == null)
          //  this.docbeginpage = this.page;

          // initialize counters to hold book/page to return to initial search.
          this.returnbook = this.book;
          this.returnpage = this.page;

          //if (this.returnbook == null)
          //  this.returnbook = this.book;
          //if (this.returnpage == null)
          //  this.returnpage = this.page;

          this.documents.push(this.record.docDetail);
          this.isLoadingDetail = false;
          this.isLoadingImage = true;
          this.getImageByBookPage(this.book, this.page);
          //this.getImageByDocNum(this.docId);
          this.changeNavigationbutton(this.pageCount);
          this.changeInInfo.emit(data);

        },
        error => { this.error = error }
      );
    } else {
      console.log('No doc record ' + this.book + '' + this.page);
      this.getImageByBookPage(this.book, this.page);
      //this.getImageByDocNum(this.docId);

    }
    //let cnt = JSON.parse(localStorage.getItem("basket")).length;
    //this.SBService.updateBasketCount(cnt);;
    let cnt = JSON.parse(localStorage.getItem("basket"));
    if (cnt !== null)
      this.SBService.updateBasketCount(JSON.parse(localStorage.getItem("basket")).length);
    else
      this.SBService.updateBasketCount(0);

  }

  loadRef(e: InstrumentVM) {
//    console.log(`loadRef fired: ${e}`);
    console.log(`loadRef fired: ${e.docID}`);
    this.record = null;
    this.isLoadingDetail = true;
    this.isLoadingImage = true;
    this.docId = e.docID;
    this.book = e.primaryID;
    this.page = e.secondaryID;
    this.docbeginbook = e.primaryID;
    this.docbeginpage = e.secondaryID;
    this.sBook = '';
    this.sPage = '';
    this.currentIndex = 1;
    this.index_page = '0';
    this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.documents = new Array<InstrumentVM>();
    this.blobImage = '';


    this.ngOnInit();
  }

  getImageByBookPage(book: string, page: string, push: boolean = true) {
    console.log('getImageByBP recdocdetailparent fired');
    this.isLoadingImage = true;
    console.log("current book and page" + book + page);
    //console.log("type " + this.record.docDetail.docType);
    this.service.getImageByBookAndPage(book, page, this.currentIndex, this.searchType).subscribe(
      data => {
        if (push) {
          this.docImages.push(data);
          console.log('img ' + data.length);
          console.log('push ' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.shift();
            console.log('shift' + this.docImages.length);
            this.currentImageIndex = this.bufferSize;

          }
          else {
            this.currentImageIndex++;
          }

          console.log("docimages and CII " + this.docImages.length + " " + this.currentImageIndex);
        }
        else {
          this.docImages.splice(0, 0, data);
          console.log('splice' + this.docImages.length);
          //TODO: code to manage the size of the docImages array
          if (this.docImages.length > this.bufferSize) {
            this.docImages.pop();
            console.log('pop' + this.docImages.length);
            this.currentImageIndex = 1;
          }
          else {
            this.currentImageIndex = 1;
          }
        }
        if (this.pageCount === 0 && data.length > 0)
          this.pageCount = 1;
        this.showImage((this.currentImageIndex - 1));
        //this.isLoadingImage = false;
      },
      error => { this.error = error }
    );
    this.showimgviewer();
  }

  //getImageByDocNum(docID: number, push: boolean = true) {
  //  //this.isLoadingImage = true;
  //  console.log("current doc ID" + docID);
  //  this.service.getImageByDocId(docID).subscribe(
  //    data => {
  //      if (push) {
  //        this.docImages.push(data);
  //        console.log('push' + this.docImages.length);
  //        //TODO: code to manage the size of the docImages array
  //        if (this.docImages.length > this.bufferSize) {
  //          this.docImages.shift();
  //          console.log('shift' + this.docImages.length);
  //          this.currentImageIndex = this.bufferSize;

  //        }
  //        else {
  //          this.currentImageIndex++;
  //        }

  //        console.log("docimages and CII" + this.docImages.length + this.currentImageIndex);
  //      }
  //      else {
  //        this.docImages.splice(0, 0, data);
  //        console.log('splice' + this.docImages.length);
  //        //TODO: code to manage the size of the docImages array
  //        if (this.docImages.length > this.bufferSize) {
  //          this.docImages.pop();
  //          console.log('pop' + this.docImages.length);
  //          this.currentImageIndex = 1;
  //        }
  //        else {
  //          this.currentImageIndex = 1;
  //        }
  //      }
  //      this.showImage((this.currentImageIndex - 1));
  //      //this.isLoadingImage = false;
  //    },
  //    error => { this.error = error }
  //  );
  //  this.showimgviewer();
  //}



  showImage(idx: number) {
    console.log('showImage')
    this.isLoadingImage = true;
    if (this.currentImage.length === 1) {
      this.currentImage.pop();
    }
    this.currentImage.push(this.docImages[idx]);
    this.blobImage = this.docImages[idx];
    //this.pdfViewer.base64Src = this.docImages[idx];
    //this.pdfViewer.refresh();
    this.isLoadingImage = false;
    this.rePaintImgViewer();
  }

  /**
   * Navigate to previous page.
   * @param url
   */
  back(url) {

    this.router.navigate([url]);
    //window.opener = 'Self';
    //window.open('', '_parent', '');
    //window.close();

  }

  showimgviewer() {
    console.log('showimgviewer');
    this.showimageviewer = true;
    this.isImgVwVisible = false;
    this.isLoadingImage = false;
    if (this.imgvwr) this.imgvwr.download = false;
    this.changeImgVwVisible.emit(this.isImgVwVisible);
  }


  /**
   * Search document for a book and page number entered by the user.
   * @param sBook
   * @param sPage
   */
  searchDocument(sBook: string, sPage: string) {
    //this.docImages = new Array<string>();
    //this.currentImage = new Array<string>();
    //this.documents = new Array<InstrumentVM>();

    //this.currentIndex = 1;
    //this.currentImageIndex = 0;
    //this.isLoadingDetail = true;

    console.log('searchdoc');
    var inst = new InstrumentVM();
    this.searchType = 'deeds';

    this.service.getInstrument(sBook, sPage, this.searchType).subscribe(
      data => {
        inst = data;
        this.loadRef(inst);

      },
      error => { this.error = error }

    );

    return;


  //  this.service.getContainingDoc(sBook, sPage).subscribe(
  //    data => {
  //      this.docId = data.docID;
  //      this.book = data.primaryID;
  //      this.page = data.secondaryID;
  //      this.docbeginbook = data.primaryID;
  //      this.docbeginpage = data.secondaryID;

  //      this.service.getRecDoc(this.docId).subscribe(
  //        data => {
  //          this.record = data;

  //          this.pageCount = data.docDetail.pageCount;
  //          this.documents.push(this.record.docDetail);

  //          this.isLoadingDetail = false;
  //          this.isLoadingImage = true;

  //          this.changeNavigationbutton(this.pageCount);
  //          this.getImageByBookPage(this.book, this.page, true);
  //          this.changeInInfo.emit(data);
  //        },
  //        error => { this.error = error }
  //      );

  //    },
  //    error => { this.error = error }
  //  );
  }


//  padLeft(text: string, padChar: string, size: number): string {
//  return (String(padChar).repeat(size) + text).substr((size * -1), size);
//  }

  searchPlan(book: string, page: string) {

    let loc = localStorage.getItem("machineLocation")

    let BookNo = +book;
    let PageNo = +page;
    console.log('searchplan ' + book + ' ' + page);

    //this.service.GetPlanDoc(book, PageNo).toPromise()
    //  .then(res => {
    //    //var cutoffDt = new Date('5/1/2017');
    //    //var fileDt = new Date(res.fileDate);
    //    //          if (fileDt < cutoffDt || res.planID === 0) {
    //    //if ((+res.book < 238 ) || (+res.book === 238 && +res.page < 37)) {
    //    if (this.service.isInPlanFolder(res.book, res.page)) {
    //      var planID = res.planID;
    //      if (+book < 238)
    //        planID = 0;
    //      //url = '/rec-plan-name-doc-disp-pg/' + book + '/' + page + '/' + res.planID;
    //      const url = this.router.createUrlTree(['/rec-plan-name-doc-disp-pg/', book, page, planID]);
    //      const tUrl = this.appurl + url.toString().substring(1);
    //      if (loc == '1') {
    //        var params = [
    //          'height=' + screen.height,
    //          'width=' + screen.width,
    //          'fullscreen=yes' // only works in IE, but here for completeness
    //        ].join(',');

    //        var popup = window.open(tUrl, 'popup_window', params);
    //        if (popup) {
    //          popup.moveTo(0, 0);
    //          popup.focus();
    //        } else {
    //          alert('Popup was blocked. Please allow popups for this site.');
    //        }

    //      } else {
    //        window.open(tUrl, '_blank');
    //      }
    //      //this.router.navigate(['/rec-plan-name-doc-disp-pg/', book, page, planID]);
    //    }
    //    else {
    //      const url = this.router.createUrlTree(['/rec-address-doc-disp-pg', res.planID, book, page]);
    //      const tUrl = this.appurl + url.toString().substring(1);
    //      if (loc == '1') {
    //        var params = [
    //          'height=' + screen.height,
    //          'width=' + screen.width,
    //          'fullscreen=yes' // only works in IE, but here for completeness
    //        ].join(',');

    //        var popup = window.open(tUrl, 'popup_window', params);
    //        if (popup) {
    //          popup.moveTo(0, 0);
    //          popup.focus();
    //        } else {
    //          alert('Popup was blocked. Please allow popups for this site.');
    //        }
    //      } else {
    //        window.open(tUrl, '_blank');
    //      }
    //    }
    //  });


    
    //check the range of plans that are stored with land records
    if ((BookNo > 238) || (BookNo == 238 && PageNo > 36/*36*/)) {

      console.log('deedplan ' + book + ' ' + page);
      //display window in current page
      var inst = new InstrumentVM();
      this.searchType = 'all';

      this.service.getInstrument(book, page, this.searchType).subscribe(
        data => {
          inst = data;
          this.loadRef(inst);
        },
        error => { this.error = error }

      );

    } else {
      console.log('plan book ' + book + ' ' + page);
      //else route it to the old plans folder
      book = this.service.padLeft(book, '0', 4);
      page = this.service.padLeft(page, '0', 4);
      console.log('go to plan ' + book + ' ' + page);
        const url = this.router.createUrlTree(['rec-plan-name-doc-disp-pg', book, page, 'Recorded'])


        console.log(this.appurl);

        const tUrl = this.appurl + url.toString().substring(1);
        console.log(tUrl);

        this.router.navigate(['rec-plan-name-doc-disp-pg', book, page, 'Recorded']);
      }

    this.sPlanBook = '';
    this.sPlanPage = '';

  }

  /**
   * Navigates to first page of next document.
   * @param event
   */
  getNextDocument(event: Event) {

    console.log('getNextDocument fired - ' + this.currentImageIndex);
    console.log('BP - ' + this.documents[0].docBPGroup);
    console.log('TYPE - ' + this.record.docDetail.docType);
    this.docImages = new Array<string>();
    //this.documents && this.documents.length > 0 && this.documents[0].docBPGroup == "B"
    //if (this.documents && this.documents.length > 0 && this.documents[0].docBPGroup == "B") {


    //if (this.documents[0].docBPGroup == "B") {
    //  this.currentImage = new Array<string>();
    //  this.getNextPg(event);
    //  this.currentImageIndex = 0;
    //  this.currentIndex = 1;
    //  this.docbeginbook = this.book;
    //  this.docbeginpage = this.page;

    //} else {


      //this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.documents = new Array<InstrumentVM>();

    this.sBook = '';
    this.sPage = '';
    this.currentIndex = 1;
    this.currentImageIndex = 0;
    this.isLoadingDetail = true;

    // Get next document
    this.service.getNextRecDocBP(this.docbeginbook, this.docbeginpage, this.record.docDetail.docType).subscribe(
        data => {
          this.record = data;
          this.docbeginbook = data.docDetail.primaryID;
          this.docbeginpage = data.docDetail.secondaryID;
          this.book = data.docDetail.primaryID;
          this.page = data.docDetail.secondaryID;
          this.docId = data.docID;
          this.pageCount = data.docDetail.pageCount;
          this.isPlanBook = (this.record.docDetail.docType == 'PL' && +this.docbeginbook <= this.planBookLimit);
          this.documents.push(this.record.docDetail);
          this.showPaging = +this.book >= this.pagingBookLimit;
          this.isLoadingDetail = false;
          this.isLoadingImage = true;
          console.log("getnextrecdoc " + this.book + "-" + this.page + ' ' + data.docID);
          this.getImageByBookPage(this.book, this.page, true);
          this.changeNavigationbutton(this.pageCount);
          this.changeInInfo.emit(data);
          this.showPaging = (+this.book >= this.pagingBookLimit || this.book === 'AX0000');
          if (this.showPaging) console.log("SHOW PAGING");
        },
        error => { this.error = error }
      );

    //}
  }


  /**
 * Navigates to first page of previous document.
 * @param event
 */
  getPrevDocument(event: Event) {

    console.log('getPrevDocument fired - ' + this.currentImageIndex);
    console.log('BP - ' + this.documents[0].docBPGroup);
    console.log('TYPE - ' + this.record.docDetail.docType);
    this.docImages = new Array<string>();
    //this.documents && this.documents.length > 0 && this.documents[0].docBPGroup == "B"
    //if (this.documents && this.documents.length > 0 && this.documents[0].docBPGroup == "B") {

    //if (this.documents[0].docBPGroup == "B") {
    //  this.currentImage = new Array<string>();
    //  this.getPrevPg(event);
    //  this.currentImageIndex = 0;
    //  this.currentIndex = 1;
    //  this.docbeginbook = this.book;
    //  this.docbeginpage = this.page;

    //} else {

      this.docImages = new Array<string>();
      this.currentImage = new Array<string>();
      this.documents = new Array<InstrumentVM>();

      this.sBook = '';
      this.sPage = '';

      this.currentIndex = 1;
      this.currentImageIndex = 0;
      this.isLoadingDetail = true;

    console.log(this.record.docDetail.docType);
    this.service.getPrevRecDocBP(this.docbeginbook, this.docbeginpage, this.record.docDetail.docType).subscribe(
        data => {
          this.record = data;
          this.docbeginbook = data.docDetail.primaryID;
          this.docbeginpage = data.docDetail.secondaryID;
          this.pageCount = data.docDetail.pageCount;
          this.docId = data.docID;;
          this.book = data.docDetail.primaryID;
          this.page = data.docDetail.secondaryID;
          this.documents.push(this.record.docDetail);
          this.showPaging = +this.book >= this.pagingBookLimit;
          this.isPlanBook = (this.record.docDetail.docType == 'PL' && +this.docbeginbook <= this.planBookLimit);
          this.isLoadingDetail = false;
          this.isLoadingImage = true;

          this.getImageByBookPage(this.book, this.page, true);
          this.changeNavigationbutton(this.pageCount);
          this.changeInInfo.emit(data);
          this.showPaging = (+this.book >= this.pagingBookLimit || this.book === 'AX0000');
          if (this.showPaging) console.log("SHOW PAGING");
        },
        error => { this.error = error }
      );
    //}
  }

  /**
   * Return to start of Search.
   * @param returnbook
   * @param returnpage
   */
  returnToStart(returnbook: string, returnpage: string) {
    console.log('returnToStart fired');
    this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    this.documents = new Array<InstrumentVM>();

    this.sBook = '';
    this.sPage = '';

    this.currentIndex = 1;
    this.currentImageIndex = 0;
    this.isLoadingDetail = true;


    this.service.getContainingDoc(returnbook, returnpage, this.searchType).subscribe(
      data => {
        this.docId = data.docID;
        this.book = data.primaryID;
        this.page = data.secondaryID;
        this.docbeginbook = data.primaryID;
        this.docbeginpage = data.secondaryID;

        this.service.getRecDoc(this.docId).subscribe(
          data => {
            this.record = data;

            this.pageCount = data.docDetail.pageCount;
            this.documents.push(this.record.docDetail);

            this.isLoadingDetail = false;
            this.isLoadingImage = true;

            this.changeNavigationbutton(this.pageCount);
            this.getImageByBookPage(this.book, this.page, true);
            this.changeInInfo.emit(data);
          },
          error => { this.error = error }
        );

      },
      error => { this.error = error }
    );
  }

  /**
   * Navigate to next page of a document.
   * @param event
   */
  getNextPg(event: Event) {
//    console.log('getNextPage fired');
    ////////////
    if (this.documents[0].docBPGroup != "B")
      this.currentIndex++;
    else {
      var nextPg: number;
      nextPg = +this.page + 1;
      this.page = nextPg.toString();
      console.log('next page ' + nextPg);
    }

    //this.docImages = new Array<string>();
    this.currentImage = new Array<string>();
    //this.currentIndex = 1;
    //this.currentImageIndex = 0;
    /////////////
     
    console.log("nxt pg CI " + this.currentIndex);
    this.service.getNextBP(this.book, this.page, this.currentIndex).subscribe(
      data => {
        //this.book = data.primaryID;
        //this.page = data.secondaryID;
        console.log("getnextbp -  " + this.docImages.length + " - " + this.currentImageIndex);
        if (this.docImages.length > this.currentImageIndex) {
          this.showImage(this.currentImageIndex);
          this.currentImageIndex++;
        }
        else {
          console.log("getnextpg - getimagebybookpage")
          this.getImageByBookPage(this.book, this.page, true);
        }

        this.changeNavigationbutton(this.pageCount);
      },
      error => { this.error = error }
    );


  }

  /**
   * Navigate to previous page of a document.
   * @param event
   */
  getPrevPg(event: Event) {
    console.log('getPrevPg fired');

    if (this.documents[0].docBPGroup != "B")
      this.currentIndex--;
    else {
      var prevPg: number;
      prevPg = +this.page - 1;
      if(prevPg > 0)
        this.page = prevPg.toString();
        console.log('prev page ' + prevPg);
    }

    this.currentImage = new Array<string>();
    console.log("prv pg CI " + this.currentIndex);

    this.service.getPrevBP(this.book, this.page).subscribe(
      data => {
        //this.book = data.primaryID;
        //this.page = data.secondaryID;

        if (this.currentImageIndex > 1) {
          this.showImage((this.currentImageIndex - 2));
          this.currentImageIndex--;
        }
        else {
          this.getImageByBookPage(this.book, this.page, false);
        }
        this.changeNavigationbutton(this.pageCount);
      },
      error => { this.error = error }
    );
    
  }

  checkIfFirstPage(): boolean {
    console.log('checkIfFirstPage fired');
    if (this.currentIndex == 1) {
      return true;
    }
    else
      return false;
  }
  checkIfLastPage(): boolean {
    if (this.currentIndex == this.pageCount) {
      return true;
    }
    else
      return false;
  }

  rePaintImgViewer() {
    console.log('repaint');
    //this.imgvwr = new ImageViewerComponent(this.renderer);
    //this.imgvwr.images = this.currentImage;
    //this.imgvwr.idContainer = "idOnHTML";
    //this.imgvwr.download = false;


    this.showimgviewer();
 
  }

  /**
   * Enable/Disable the navigation button, when its a first page or last page in the document.
   * @param pageCount
   */
  changeNavigationbutton(pageCount: number) {
    console.log('changeNavigationButton fired');
    // Enable/disable navigation buttons.
    //console.log(this.book + "/" + this.page);
    //console.log("Next doc page count " + this.pageCount)
    if (this.pageCount > 1) {
      if (this.currentIndex == 1) {
        this.isFirstPage = true;
        this.isLastPage = false;
        console.log("1");
      }
      else if (this.currentIndex == this.pageCount) {
        this.isLastPage = true;
        this.isFirstPage = false;
        console.log("2");
      }
      else {
        this.isLastPage = false;
        this.isFirstPage = false;
        console.log("3");
      }

    }

    else {
      if (this.pageCount == 0) {
              this.isLastPage = false;
              this.isFirstPage = false;
              console.log("4a");
      } else {
            this.isLastPage = true;
            this.isFirstPage = true;
            console.log("4");
        }
    }

    //console.log(this.isFirstPage);
    //console.log(this.isLastPage);
  }

  /**
   * Navigate to First page in a document.
   * @param event
   */
  getFirstPg(event: Event) {
    console.log('getFirstPg fired');
    console.log("firstpg" + this.pageCount);
    this.book = this.docbeginbook;
    this.page = this.docbeginpage;

    this.currentImage = new Array<string>();

    // Get first page from cache if present.
    if (this.currentIndex <= this.bufferSize && this.currentImageIndex !== 1) {
      this.currentIndex = 1;
      this.currentImageIndex = 1;
      this.showImage(this.currentImageIndex -1);
      this.changeNavigationbutton(this.pageCount);
    }

    // get first page from service when its not present in cache.
    else {
      this.currentIndex = 1;
      this.currentImageIndex = 0;
      this.docImages.length = 0;
      this.getImageByBookPage(this.book, this.page,true);
      this.changeNavigationbutton(this.pageCount);
    }
  }

  /**
   * Navigate to Last page in a document.
   * @param event
   */
  getLastPg(event: Event) {
    console.log("lastpg" + this.pageCount)
    this.book = this.docbeginbook;
    //this.page = (Number(this.docbeginpage) + this.pageCount - 1).toString();
    let lastPgIdx: number = this.pageCount - 1;
    this.currentImageIndex = lastPgIdx;

    this.currentImage = new Array<string>();

    // Get last page from cache if present.
    if (this.pageCount <= this.bufferSize && this.docImages[lastPgIdx] != null) {
      this.currentImageIndex = this.pageCount - 1;
      this.currentIndex = this.pageCount;
      this.showImage(this.currentImageIndex);
      this.changeNavigationbutton(this.pageCount);
    }


    ////get last page from service when its not present in cache.
    else {
      this.currentImageIndex = 0;
      this.currentIndex = this.pageCount;
      this.docImages.length = 0;
      this.getImageByBookPage(this.book, this.page, false);
      this.changeNavigationbutton(this.pageCount);
    }
  }


  allowDrop(ev) {
    console.log("allow drop");
    ev.preventDefault();
  }

  drag(ev) {
    console.log("drag");
    ev.dataTransfer.setData("text", ev.target.id);
  }

  drop(doctype, beginbook, beginpage, currentindex) {
    console.log("drop");
    console.log("doctype" + doctype + "begbook" + beginbook + "begpage" + beginpage + "currentindex" + currentindex);

    this.docBasketChild.basketItems = JSON.parse(localStorage.getItem("basket"));
    if (this.docBasketChild.basketItems == null)
      this.docBasketChild.basketItems = new Array<basketVM>();

    const index = this.docBasketChild.basketItems.findIndex(item => item.beginBook === beginbook && item.beginPage === beginpage && item.wholeDoc === false);
    if (index > -1) {
      if (this.docBasketChild.basketItems[index].pages.indexOf(currentindex.toString()) > -1) {
        console.log("Duplicate entry");
        this.Message = "Book/Page " + beginbook + "/" + beginpage + ", p." + (currentindex) + " is already added.";
        this.popupVisible = true;
      }
      else {
        this.docBasketChild.basketItems[index].pageCount = this.docBasketChild.basketItems[index].pageCount + 1;
        this.docBasketChild.basketItems[index].pages.push(currentindex.toString());
        console.log("Updated entry");
        this.Message = "Book/Page " + beginbook + "/" + beginpage + ", p." + (currentindex) + " is added successfully.";
        this.popupVisible = true;
      }
    }

    else {
      this.basketItem = new basketVM();
      this.basketItem.docType = doctype;
      this.basketItem.bookpage = 'B:' + beginbook + '/P:' + beginpage;
      this.basketItem.beginBook = beginbook;
      this.basketItem.beginPage = beginpage;
      this.basketItem.isEmail = false;
      this.basketItem.isDownload = false;
      this.basketItem.downloadAs = 'pdf';
      this.basketItem.wholeDoc = false;
      this.basketItem.pageCount = 1;
      this.basketItem.pages = new Array<string>(currentindex.toString());
      this.basketItem.dept = 'R';

      this.docBasketChild.basketItems.push(this.basketItem);
      //update local storage

      
      //if (localStorage.getItem("basket").length > 0) {
      //  let basketls = JSON.parse(localStorage.getItem("basket"));
      //  basketls.push(this.basketItem);
      //  localStorage.setItem("basket", JSON.stringify(basketls));

      //}

      //localStorage.setItem("basket", JSON.stringify(this.docBasketChild.basketItems));
      
      console.log("Added entry");
      this.Message = "Book/Page " + beginbook + "/" + beginpage + ", p." + (currentindex) + " is added successfully.";
      this.popupVisible = true;
    }

    localStorage.setItem("basket", JSON.stringify(this.docBasketChild.basketItems));

    //let cnt = JSON.parse(localStorage.getItem("basket")).length;
    //this.SBService.updateBasketCount(cnt);
    //this.docBasketChild.checkHiddenDocument();
    //this.SBService.forceRefresh();
    this.SBService.triggerRender();
  }

  toggleGo() {
    this.collapseGo = !this.collapseGo;
  }

  toggleReturn() {
    this.collapseReturn = !this.collapseReturn;
  }

  @HostListener('window:resize', ['$event'])
  getScreenSize(event?) {
    this.screenWidth = window.innerWidth;
  }

  collapsesideinfo: boolean = false;

  toggleSideInfo() {
    this.collapsesideinfo = !this.collapsesideinfo;
  }

  @HostListener('contextmenu', ['$event'])
  onRightClick(event) {
    event.preventDefault();
  }

}
